import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdatePurchaseTenderMutationRequest, UpdatePurchaseTenderMutationResponse, UpdatePurchaseTenderQueryParams, UpdatePurchaseTender400, UpdatePurchaseTender401, UpdatePurchaseTender403, UpdatePurchaseTender422, UpdatePurchaseTender429, UpdatePurchaseTender500 } from "../types/UpdatePurchaseTender";

/**
 * @link /api/purchase-tenders/v1/update_tender
 */

export function useUpdatePurchaseTender <TData = UpdatePurchaseTenderMutationResponse, TError = UpdatePurchaseTender400 | UpdatePurchaseTender401 | UpdatePurchaseTender403 | UpdatePurchaseTender422 | UpdatePurchaseTender429 | UpdatePurchaseTender500, TVariables = UpdatePurchaseTenderMutationRequest>(params: UpdatePurchaseTenderQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/v1/update_tender`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
